export const moduleName = 'debt-sold';
export const modalTitleTranslationKey = 'modal-title';
